import { authenticatedHttpClient } from './httpClient';
import {
  Purchase,
  PurchaseCreatePayload,
  PURCHASE_LIST_PAGE_SIZE,
  PurchaseQueryResult,
  PurchaseStatus,
  PurchaseStatusCounts,
  PurchaseUpdatePayload,
} from '../models/purchase';

export const listPurchases = async (
  organizationId: string,
  filters?: {
    supplierId?: string;
    status?: PurchaseStatus;
    q?: string;
    limit?: number;
    cursor?: string;
  }
): Promise<PurchaseQueryResult> => {
  const params = new URLSearchParams();
  if (filters?.supplierId) params.append('supplier_id', filters.supplierId);
  if (filters?.status) params.append('status', filters.status);
  if (filters?.q?.trim()) params.append('q', filters.q.trim());
  params.append(
    'limit',
    String(filters?.limit ?? PURCHASE_LIST_PAGE_SIZE)
  );
  if (filters?.cursor) params.append('cursor', filters.cursor);
  const suffix = params.toString() ? `?${params.toString()}` : '';
  return authenticatedHttpClient.get<PurchaseQueryResult>(
    `/purchases/${organizationId}${suffix}`
  );
};

export const getPurchaseStatusCounts = async (
  organizationId: string
): Promise<PurchaseStatusCounts> => {
  return authenticatedHttpClient.get<PurchaseStatusCounts>(
    `/purchases/${organizationId}/status-counts`
  );
};

export const getPurchase = async (
  organizationId: string,
  purchaseId: string
): Promise<Purchase> => {
  return authenticatedHttpClient.get<Purchase>(
    `/purchases/${organizationId}/${purchaseId}`
  );
};

export const createPurchase = async (
  organizationId: string,
  payload: PurchaseCreatePayload
): Promise<Purchase> => {
  return authenticatedHttpClient.post<Purchase>(
    `/purchases/${organizationId}`,
    payload
  );
};

export const updatePurchase = async (
  organizationId: string,
  purchaseId: string,
  payload: PurchaseUpdatePayload
): Promise<Purchase> => {
  return authenticatedHttpClient.put<Purchase>(
    `/purchases/${organizationId}/${purchaseId}`,
    payload
  );
};

export const deletePurchase = async (
  organizationId: string,
  purchaseId: string
): Promise<{ ok: boolean }> => {
  return authenticatedHttpClient.delete<{ ok: boolean }>(
    `/purchases/${organizationId}/${purchaseId}`
  );
};
